export default function ImageGridFallback() {
  return (
    <div className="grid gap-1 lg:gap-3 grid-cols-4 my-6 lg:my-16 md:grid-cols-6 m-auto px-0 lg:px-4 xxl:px-10">
      <div className="relative col-span-full md:col-span-3 h-48 md:h-56 lg:h-72 xxl:h-88 bg-grey50 animate-pulse"></div>
      <div className="relative col-span-full md:col-span-3 h-48 md:h-56 lg:h-72 xxl:h-88 bg-grey50 animate-pulse hidden lg:block"></div>
      <div className="relative col-span-2 h-30 md:h-36 lg:h-56 xxl:h-66 bg-grey50 animate-pulse hidden lg:block"></div>
      <div className="relative col-span-2 h-30 md:h-36 lg:h-56 xxl:h-66 bg-grey50 animate-pulse lg:hidden"></div>
      <div className="relative col-span-2 h-30 md:h-36 lg:h-56 xxl:h-66 bg-grey50 animate-pulse"></div>
      <div className="relative col-span-2 h-30 md:h-36 lg:h-56 xxl:h-66 bg-grey50 animate-pulse hidden lg:block"></div>
    </div>
  );
}
